import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const CategoryStyled = styled.div`
  width: 100%;
  padding-left: ${p => p.theme.menuPage.menu.padding};
  padding-right: ${p => p.theme.menuPage.menu.padding};
  padding-bottom: ${p => p.theme.menuPage.menu.padding};
  ${media.medium`
     padding-left: ${p => p.theme.menuPage.tabletView.padding};
  `};
  ${media.small`
     padding-left: 0;
     padding-right: 0;
     padding-bottom: ${p => p.theme.menuPage.categoryGap};
     border-bottom: ${p => p.theme.category.borderBottom};
  `};
`;

export const RestaurantClosedMessage = styled.div`
  padding: ${p => p.theme.menuPage.menu.padding};
  margin-left: ${p => p.theme.menuPage.closedMessage.margin};
  margin-right: ${p => p.theme.menuPage.closedMessage.margin};
  margin-bottom: ${p => p.theme.margin};
  background-color: ${p => p.theme.menuPage.closedMessage.backgroundColor};
  color: ${p => p.theme.menuPage.closedMessage.color};
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  ${media.medium`
     margin-left: 0;
  `};
  ${media.small`
     margin-left: 0;
     margin-right: 0;
  `};
`;

export const CategoryHeaderStyled = styled.a`
  display: block;
  background-color: ${p => p.theme.category.header.backgroundColor};
  padding: ${p => p.theme.menuPage.menu.headerPadding};
  border-top: ${p => p.isTemplateLight ? 0 : `${p.theme.borderColor} solid ${p.theme.borderWidth}`};
  border-bottom: ${p => p.isTemplateLight ? 0 : `${p.theme.borderColor} solid ${p.theme.borderWidth}`};
  text-align: center;
  position: relative;
  &::after {
    font-family: 'icomoon';
    content: '\\f078';
    color: black;
    position: absolute;
    right: ${p => p.theme.category.header.icon.right};
    top: ${p => p.theme.category.header.icon.top};
    display: none;
  }

  ${media.small`
    cursor: pointer;
    &::after {
      display: inline-block;
      transform: ${p => p.isExpanded ? 'rotate(180deg)' : 'initial'};
      transition: transform 1s ease;
    }
  `};
`;

export const CategoryNameStyled = styled.div`
  color: ${p => p.theme.quinaryColor};
  font-size: ${p => p.theme.category.header.name.fontSize.desktop};
  text-transform: ${p => p.theme.category.header.name.textTransform};
  letter-spacing: ${p => p.theme.category.header.name.letterSpacing};
  line-height: ${p => p.theme.category.header.name.lineHeight};
  font-weight: bold;
  ${media.small`
    font-size: ${p => p.theme.category.header.name.fontSize.mobile};
    margin-right: 1.8rem;
    margin-left: 1.8rem;
  `};
`;

export const CategoryDescriptionStyled = styled.div`
  color: ${p => p.theme.quaternaryColor};
  font-size: ${p => p.theme.category.header.description.fontSize};
  min-height: ${p => p.theme.category.header.description.height};
  line-height: ${p => p.theme.category.header.description.height};
  padding-top: ${p => p.theme.category.header.description.padding};
  text-transform: ${p => p.theme.category.header.description.textTransform};
`;

export const MealCards = styled.div`
  display: block;
  ${media.small`
    display: ${props => props.isExpanded ? 'block' : 'none'};
  `};
`;

export const MealCardsLight = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${media.small`
    display: ${props => props.isExpanded ? 'flex' : 'none'};
  `};
`;



// WEBPACK FOOTER //
// ./components/Categories/Category.style.js